import { useMemo } from 'react';

import InsightsTabsFilterBar from 'components/insights/filterBar/InsightsTabsFilterBar';
import { FilterSection } from 'components/shared/filters/FilterSlideout';
import { TabType } from 'components/Tabs';
import { PREDECESSOR_GROUP } from 'constants/filterKeysConstants';
import { useBusinessDevelopmentActions, useBusinessDevelopmentStore } from 'stores/businessDevelopmentStore';

import { filtersForGroupType, getFilterSections } from '../../filters';
import { useBusinessDevelopmentContext } from '../BusinessDevelopmentContainer';

type Props = {
  tabs: TabType[];
  selectedTab?: TabType;
  onTabClick: (tab: TabType) => void;
};

export default function BusinessDevelopmentFilterBar({ tabs, selectedTab, onTabClick }: Props) {
  const { predecessorGroupType } = useBusinessDevelopmentContext();
  const selectedGroupType = useBusinessDevelopmentStore((state) => state.selectedGroupType);
  const filters = useBusinessDevelopmentStore((state) => state.filters);
  const { setSelectedFilters } = useBusinessDevelopmentActions();

  const filterSections = useMemo(
    () => getFilterSections(predecessorGroupType, selectedGroupType, PREDECESSOR_GROUP),
    [predecessorGroupType, selectedGroupType]
  );

  const activeFilters = useMemo(
    () => (selectedGroupType ? filtersForGroupType(filters, selectedGroupType, PREDECESSOR_GROUP) : filters),
    [filters, selectedGroupType]
  );

  return (
    <InsightsTabsFilterBar
      title='Business Development'
      gtmPrefix='businessDevelopment'
      tabs={tabs}
      selectedTab={selectedTab}
      onTabClick={onTabClick}
      filters={activeFilters}
      filterSections={filterSections as FilterSection[]}
      setSelectedFilters={setSelectedFilters}
    />
  );
}
